const tablePrice = {
  country: {
    zh: 'Country',
    en: 'Country',
    pu: 'País'
  },
  state: {
    zh: 'State',
    en: 'State',
    pu: 'Estado'
  },
  regions: {
    zh: 'Regions',
    en: 'Regions',
    pu: 'Regiões'
  },
  city: {
    zh: 'City',
    en: 'City',
    pu: 'Cidade'
  },
  ibgeCodes: {
    zh: 'IBGE Codes',
    en: 'IBGE Codes',
    pu: 'Código IBGE'
  },
  capitalDistance: {
    zh: 'Capital distance',
    en: 'Capital distance',
    pu: 'Distância da capital'
  },
  baseDistance: {
    zh: 'Base distance',
    en: 'Base distance',
    pu: 'Distância da base'
  },
  macroRegions: {
    zh: 'Macro regions',
    en: 'Macro regions',
    pu: 'Macro regiões'
  },
  microRegions: {
    zh: 'Micro regions',
    en: 'Micro regions',
    pu: 'Micro regiões'
  },
  deliveryPricesZoning: {
    zh: 'Delivery prices zoning',
    en: 'Delivery prices zoning',
    pu: 'Preço de entrega'
  },
  minimumShipping: {
    zh: 'Minimum shipping',
    en: 'Minimum shipping',
    pu: 'Frete mínimo'
  },
  minZipCode: {
    zh: 'Min zip code',
    en: 'Min zip code',
    pu: 'CEP mínimo'
  },
  maxZipCode: {
    zh: 'Max zip code',
    en: 'Max zip code',
    pu: 'CEP máximo'
  },
  indexZipCode: {
    zh: 'Index zip code',
    en: 'Index zip code',
    pu: 'CEP índice'
  },
  localCluster: {
    zh: 'Local cluster',
    en: 'Local cluster',
    pu: 'Cluster local'
  },
  iata: {
    zh: 'IATA',
    en: 'IATA',
    pu: 'IATA'
  },
  titularPartner: {
    zh: 'Titular partner',
    en: 'Titular partner',
    pu: 'Sócio titular'
  },
  baseAddress: {
    zh: 'Base address',
    en: 'Base address',
    pu: 'Endereço base'
  },
  segment: {
    zh: 'Segment',
    en: 'Segment',
    pu: 'Segmento'
  },
  modal: {
    zh: 'Modal',
    en: 'Modal',
    pu: 'Modal'
  },
  riskArea: {
    zh: 'Risk area',
    en: 'Risk area',
    pu: 'Área de risco'
  },
  lastMileTerm: {
    zh: 'Last mile term',
    en: 'Last mile term',
    pu: 'Prazo last mile'
  },
  addKg: {
    zh: 'Add KG',
    en: 'Add KG',
    pu: 'Adiocionar KG'
  },
  createdAt: {
    zh: 'Created at',
    en: 'Created at',
    pu: 'Criado em'
  },
  add: {
    zh: 'Add worksheet',
    en: 'Add worksheet',
    pu: 'Adicionar'
  },
  tablePrice: {
    zh: 'Table price',
    en: 'Table price',
    pu: 'Tabela de preços'
  },
  success: {
    zh: 'Successfully performed operation',
    en: 'Successfully performed operation',
    pu: 'Operação realizada com sucesso'
  },
  filters: {
    zh: 'Filters',
    en: 'Filters',
    pu: 'Filtros'
  },
  placeholderMacroRegion: {
    zh: 'Enter the macro region',
    en: 'Enter the macro region',
    pu: 'Digite a macro região'
  },
  placeholderMicroRegion: {
    zh: 'Enter the micro region',
    en: 'Enter the micro region',
    pu: 'Digite a micro região'
  },
  placeholderCountry: {
    zh: 'Enter the country',
    en: 'Enter the country',
    pu: 'Digite o país'
  },
  placeholderCity: {
    zh: 'Enter the city',
    en: 'Enter the city',
    pu: 'Digite a cidade'
  },
  placeholderState: {
    zh: 'Enter the state',
    en: 'Enter the state',
    pu: 'Digite o estado'
  },
  placeholderMaxZipCode: {
    zh: 'Enter the max zip code',
    en: 'Enter the max zip code',
    pu: 'Digite o CEP máximo'
  },
  placeholderMinZipCode: {
    zh: 'Enter the min zip code',
    en: 'Enter the min zip code',
    pu: 'Digite o CEP mínimo'
  },
  consult: {
    zh: 'Consult',
    en: 'Consult',
    pu: 'Pesquisar'
  },
  clean: {
    zh: 'Clean',
    en: 'Clean',
    pu: 'Limpar'
  },
  networkDimension: {
    zh: '网点维度',
    en: 'Branch Dimension',
    pu: 'Dimensão da Agência'
  },
  regionDimension: {
    zh: '大区维度',
    en: 'Region Dimension',
    pu: 'Dimensão Regional'
  },
  region: {
    zh: '大区',
    en: 'Region',
    pu: 'Região'
  },
  monthToDate: {
    zh: '当月累计',
    en: 'Month-to-Date',
    pu: 'Acumulado do Mês'
  },
  dailyAverage: {
    zh: '日均',
    en: 'Daily Average',
    pu: 'Média Diária'
  },
  falseDeliveryCount: {
    zh: '虚假签收数',
    en: 'False Delivery Count',
    pu: 'Contagem de Entregas Falsas'
  },
  deliveryCount: {
    zh: '签收数',
    en: 'Delivery Count',
    pu: 'Contagem de Entregas'
  },
  falseDeliveryRate: {
    zh: '虚假签收率',
    en: 'False Delivery Rate',
    pu: 'Taxa de Entregas Falsas'
  },
  dayOverDay: {
    zh: '日环比',
    en: 'Day-over-Day',
    pu: 'Variação Diária'
  },
  weekOverWeek: {
    zh: '周环比',
    en: 'Week-over-Week',
    pu: 'Variação Semanal'
  },
  monthOverMonth: {
    zh: '月环比',
    en: 'Month-over-Month',
    pu: 'Variação Mensal'
  },
  dayOverDay1: {
    zh: '环比前日',
    en: 'Day-over-Day',
    pu: 'Variação Diária'
  },
  weekOverWeek1: {
    zh: '环比上周同期',
    en: 'Week-over-Week (Same Period)',
    pu: 'Variação Semanal (Mesmo Período)'
  },
  invalidResponse: {
    zh: '无效回复',
    en: 'Invalid Response',
    pu: 'Resposta Inválida'
  },
  confirmedLost: {
    zh: '确认丢失',
    en: 'Confirmed Lost',
    pu: 'Perda Confirmada'
  },
  complaintType: {
    zh: '投诉来源',
    en: 'Complaint Type',
    pu: 'Fonte da reclamação'
  },
  consumerComplaint: {
    zh: '消费者投诉',
    en: 'Consumer Complaint',
    pu: 'Reclamação do Consumidor'
  },
  platformComplaint: {
    zh: '平台投诉',
    en: 'Platform Complaint',
    pu: 'Reclamação da Plataforma'
  },
  suspectedLost: {
    zh: '疑似丢失',
    en: 'Suspected Lost',
    pu: 'Suspeita de perda'
  },
  workOrderType: {
    zh: '投诉类型',
    en: 'Work Order Type',
    pu: 'Tipo de Reclamação'
  },
  exportDiscrepancyDetails: {
    zh: '导出差异明细',
    en: 'Export Discrepancy Details',
    pu: 'Exportar Detalhes de Discrepância'
  },
  socialMediaEscalatedComplaint: {
    zh: '社媒升级投诉',
    en: 'Social Media Escalated Complaint',
    pu: 'Reclamação Escalada em Mídia Social'
  },
  modifyResponsibleHub: {
    zh: '修改责任网点',
    en: 'Modify Responsible Hub',
    pu: 'Modificar Centro Responsável'
  },
  modifyResponsibleStage: {
    zh: '修改责任环节',
    en: 'Modify Responsible Stage',
    pu: 'Modificar Etapa Responsável'
  },
  timeRangeLimit: {
    zh: '时间范围不能超过31天',
    en: 'Time range cannot exceed 31 days',
    pu: 'O intervalo de tempo não pode exceder 31 dias'
  },
  SelectProcessingHub: {
    zh: '选择处理网点',
    en: 'Select Processing Hub',
    pu: 'Selecione o Centro de Processamento'
  },
  ActualDeliveryHub: {
    zh: '实际签收网点',
    en: 'Actual Delivery Hub',
    pu: 'Centro de Entrega Real'
  }
};
export { tablePrice };
